import classNames from "classnames";

import styles from './text-mock-screen.module.scss';

export interface TextMockScreenProps {
	text: string;
}

export const TextMockScreen = (props: TextMockScreenProps) => {
	return (
		<div className={classNames("flex-size-fill", styles.container)}>
			{ props.text }
		</div>
	)
}